import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Add, ArrowBack, Done, Edit } from "@mui/icons-material";
import {
  ACTUALIZAR_UNIDAD_NEGOCIO,
  CREAR_UNIDAD_NEGOCIO,
} from "../graphql/mutations";
import { useMutation } from "@apollo/client";
import { MainContext } from "../../../../../Context/MainCtx";
import { CircularProgress } from "@mui/material";
import { isMobile } from "../../../../../Config/constantes";

export default function NuevaUnidadN({
  edit,
  data,
  refetch,
  external = false,
  refetchExternal = null,
}) {
  const [open, setOpen] = React.useState(false);
  const [nombreUnidad, setUnidadNegocio] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const { snackMessage, tokenDecoded } = React.useContext(MainContext);
  const [crearUnidadNegocio] = useMutation(CREAR_UNIDAD_NEGOCIO);
  const [actualizarUnidadNegocio] = useMutation(ACTUALIZAR_UNIDAD_NEGOCIO);

  const handleOpen = () => {
    setOpen(true);
    if (edit) setUnidadNegocio(data.nombreUnidad);
  };
  const handleClose = () => {
    setOpen(false);
    setUnidadNegocio("");
  };

  const handleSaveUnidad = async (e) => {
    try {
      e.stopPropagation();
      e.preventDefault();
      if (!nombreUnidad) return;
      setLoading(true);
      if (!edit) {
        //si es nuevo
        const res = await crearUnidadNegocio({
          variables: {
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            nombreUnidad,
          },
        });
        snackMessage({
          message: res.data.crearUnidadNegocio.message,
          variant: "success",
        });
      } else {
        //si va a actualizar
        const res = await actualizarUnidadNegocio({
          variables: {
            idUnidad: data._id,
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            nombreUnidad,
          },
        });
        snackMessage({
          message: res.data.actualizarUnidadNegocio.message,
          variant: "success",
        });
      }
      if (external && refetchExternal) refetchExternal();
      if (refetch) refetch();
      setLoading(false);
      handleClose();
    } catch (err) {
      setLoading(false);
      snackMessage({
        message: err.message ? err.message : "Error Desconocido",
        variant: "error",
      });
    }
  };

  return (
    <div>
      {edit ? (
        <IconButton onClick={handleOpen}>
          {loading ? <CircularProgress size={20} color="inherit" /> : <Edit />}
        </IconButton>
      ) : external ? (
        <IconButton onClick={handleOpen} size="small" color="primary">
          <Add />
        </IconButton>
      ) : (
        <Button
          startIcon={isMobile ? null : <Add />}
          color="primary"
          variant="contained"
          onClick={handleOpen}
          size="small"
          disableElevation
          sx={{ textTransform: "none", minWidth: 40 }}
        >
          {isMobile ? <Add fontSize="small" /> : "Nuevo"}
        </Button>
      )}
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        ModalProps={{
          componentsProps: {
            backdrop: {
              sx: { background: "none" },
            },
          },
        }}
        PaperProps={{
          elevation: 1,
          sx: { width: { xs: "100vw", md: "40vw" } },
        }}
      >
        <Toolbar variant="dense" />
        <DialogTitle>
          <Stack spacing={1} direction="row" alignItems="center">
            <IconButton onClick={() => handleClose()}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h6">
              {edit ? `Editar` : "Nueva forma"}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Button
              startIcon={
                loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <Done />
                )
              }
              variant="contained"
              disableElevation
              sx={{ textTransform: "none" }}
              size="small"
              type="submit"
              form="formUnidad"
            >
              Guardar
            </Button>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ py: 0 }}>
          <form id="formUnidad" onSubmit={handleSaveUnidad}>
            <TextField
              placeholder="Nombre de la unidad de negocio"
              size="small"
              variant="outlined"
              margin="dense"
              fullWidth
              onChange={(e) => setUnidadNegocio(e.target.value)}
              value={nombreUnidad}
              required
            />
          </form>
        </DialogContent>
      </Drawer>
    </div>
  );
}
